import * as THREE from "three";
import * as PANOLENS from "panolens";
import {toggleStarWarp} from "../starwarp";
import {getLAT} from "./LAT_main";
import {createBackgroundPlane, createPlane, jumpFlappy, setupFlappyBird, startGame} from "../bird/flappybirdgame";
import {createCircleTexture} from "../three/canvastexture";
import {createDotsTexture} from "../three/dotstexture";
import {b64TransparentImage} from "./panorama";

const points = []

const funLogic = {
    colorscreen: ()=>{
        let originalMaterial = null;
        const start = () => {
            getLAT().cockpit.screens.forEach(screen => {
                if(originalMaterial === null) originalMaterial = screen.material.clone();
                screen.material = new THREE.MeshBasicMaterial({
                    map: createDotsTexture(()=>{
                        getLAT().cockpit.screens.forEach(screen => screen.material.map.needsUpdate = true)
                        // mesh.material.map.needsUpdate = true
                        // console.log('rendercallback', mesh.name)
                    })
                });
            })
        }
        const stop = ()=> {
            if(originalMaterial === null) return;
            getLAT().cockpit.screens.forEach(screen => {
                if (screen.material.map.stopRender !== undefined) {
                    console.log('stop render color screen');
                    screen.material.map.stopRender();
                }
                screen.material = originalMaterial;
            });
            originalMaterial = null;
        }
        window.colorScreen = () => start()
        return {start, stop};
    },
    starwarp: ({vec})=> {
        const marker = new PANOLENS.Infospot(150, '/graphics/star-shooting.png');
        marker.position.copy(new THREE.Vector3(...vec));
        marker.addEventListener('click', ()=>{

            const alphaMapSrc = '/airplanes/B787/787_Battery_OFF_transparent.png'
            const storedAlphaMap = getLAT().panorama.material.alphaMap;
            new THREE.TextureLoader().load( alphaMapSrc, texture => {
                getLAT().panorama.material.alphaMap = texture
                getLAT().panorama.material.needsUpdate = true;
            } )
            toggleStarWarp(getLAT().scene, ()=>{
                getLAT().panorama.material.alphaMap = storedAlphaMap
                getLAT().panorama.material.needsUpdate = true;
            });
        })
        getLAT().scene.add(marker)
        return {marker}
    },
    flappy: ({vec_start, vec_play}) => {
        const marker = new PANOLENS.Infospot(300, b64TransparentImage);
        marker.position.copy(new THREE.Vector3(...vec_start));
        marker.addEventListener('click', ()=>{
            if(isFlappyRunning()){
                if(registeredFun.colorscreen){
                    registeredFun.colorscreen.stop();
                }
                return stopFlappy();
            }

            if(registeredFun.colorscreen){
                registeredFun.colorscreen.start();
            }
            startFlappy();
            const playMarker = new PANOLENS.Infospot(300, '/graphics/gamepad-variant-outline.png');
            playMarker.position.copy(new THREE.Vector3(...vec_play));
            playMarker.show();
            getLAT().scene.add(playMarker)
            addedObjects.push(playMarker)
            playMarker.addEventListener('click', jumpFlappy);

        });
        getLAT().scene.add(marker)


        startGame()

        let addedObjects = [];

        let storedAlphaMap = null;

        const isFlappyRunning = () => addedObjects.length > 0;

        const startFlappy = ()=>{

            const flappyPlane = createPlane(()=>{
                flappyPlane.material.map.needsUpdate = true;
            });
            const planeX = -5020;
            flappyPlane.rotateY(Math.PI/2)
            flappyPlane.scale.set(5.4,4,1)
            flappyPlane.position.set(planeX, 350, 0)
            addedObjects.push(flappyPlane)
            getLAT().scene.add(flappyPlane)

            const grassPlane = createBackgroundPlane(50000, 1000, false)
            grassPlane.rotateY(Math.PI/2)
            grassPlane.position.set(planeX-10, -700, 0)
            addedObjects.push(grassPlane)
            getLAT().scene.add(grassPlane)

            const skyPlane = createBackgroundPlane(50000, 5000, true)
            skyPlane.rotateY(Math.PI/2)
            skyPlane.position.set(planeX-20, 300, 0)
            getLAT().scene.add(skyPlane)
            addedObjects.push(skyPlane)


            storedAlphaMap = getLAT().panorama.material.alphaMap;
            const alphaMapSrc = '/airplanes/B787/787_Battery_OFF_transparent_frontonly.png'
            new THREE.TextureLoader().load( alphaMapSrc, texture => {
                getLAT().panorama.material.alphaMap =  texture
                getLAT().panorama.material.needsUpdate = true;

            } )
        }

        const stopFlappy = () => {
            addedObjects.forEach(obj => {
                getLAT().scene.remove(obj)
                if(obj.parent){
                    obj.parent.remove(obj)
                }
                getLAT().panorama.material.alphaMap = storedAlphaMap;
                getLAT().panorama.material.needsUpdate = true;
            })
            addedObjects = []
        }

        window.startFlappy = () => startFlappy();
        window.stopFlappy = () => stopFlappy();

        return {startFlappy, stopFlappy, isFlappyRunning, marker}
    }
}

let registeredFun = {};

export function registerFun(cockpitConfig){
    if(!cockpitConfig.fun) return;
    for(let name in cockpitConfig.fun){
        if(cockpitConfig.fun.hasOwnProperty(name) && funLogic[name]) {
            registeredFun[name] = funLogic[name](cockpitConfig.fun[name]);
        }
    }
}